import { Modal } from 'bootstrap';

export const showModal = (options: { title: string; body: string; fullScreen?: boolean }) => {
  const modalElement = document.getElementById('modal');

  if (modalElement) {
    const modalDialogElement = modalElement.querySelector('.modal-dialog')!;
    const modalTitleElement = modalElement.querySelector('.modal-title')!;
    const modalBodyElement = modalElement.querySelector('.modal-body')!;

    modalDialogElement.classList.toggle('modal-fullscreen', !!options?.fullScreen);
    modalTitleElement.innerHTML = options.title;
    modalBodyElement.innerHTML = options.body;

    new Modal(modalElement).show();
  }
};
